import React, { useState } from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Chip,
  Box,
  IconButton,
  Collapse,
  Button,
  Switch,
  FormControlLabel
} from '@mui/material';
import {
  Edit,
  Delete,
  ExpandMore,
  ExpandLess,
  FileCopy,
  PlayArrow
} from '@mui/icons-material';
import { describeCondition, describeAction } from '../../../utils/transformations/ruleTransformations';

const RuleCard = ({ rule, onEdit, onDelete, onDuplicate, onTest, onToggleActive }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Card
      variant="outlined"
      sx={{
        mb: 2,
        borderLeft: `4px solid ${rule.isActive ? '#4caf50' : '#9e9e9e'}`
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 1 }}>
              <Chip
                label={`Priority ${rule.priority}`}
                size="small"
                color="primary"
                sx={{ fontWeight: 'bold' }}
              />
              <Typography variant="h6" component="div">
                {rule.name}
              </Typography>
            </Box>

            {rule.description && (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {rule.description}
              </Typography>
            )}

            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 2 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={rule.isActive !== false}
                    onChange={(e) => onToggleActive(rule, e.target.checked)}
                    size="small"
                  />
                }
                label={<Typography variant="caption">{rule.isActive !== false ? 'Active' : 'Inactive'}</Typography>}
              />
            </Box>
          </Box>

          <Box sx={{ display: 'flex', gap: 0.5 }}>
            <IconButton size="small" onClick={() => setExpanded(!expanded)} color="primary">
              {expanded ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
            <IconButton size="small" onClick={() => onEdit(rule)} color="primary">
              <Edit fontSize="small" />
            </IconButton>
            <IconButton size="small" onClick={() => onDuplicate(rule)} color="secondary">
              <FileCopy fontSize="small" />
            </IconButton>
            <IconButton size="small" onClick={() => onTest(rule)} color="info">
              <PlayArrow fontSize="small" />
            </IconButton>
            <IconButton size="small" onClick={() => onDelete(rule)} color="error">
              <Delete fontSize="small" />
            </IconButton>
          </Box>
        </Box>

        <Collapse in={expanded}>
          <Box sx={{ mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
            <Typography variant="subtitle2" gutterBottom>
              Conditions:
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, fontFamily: 'monospace', fontSize: '0.85rem' }}>
              {describeCondition(rule.conditions)}
            </Typography>

            <Typography variant="subtitle2" gutterBottom>
              Action:
            </Typography>
            <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>
              {describeAction(rule.action)}
            </Typography>

            {rule.action?.reason && (
              <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1, fontStyle: 'italic' }}>
                "{rule.action.reason}"
              </Typography>
            )}
          </Box>
        </Collapse>
      </CardContent>
    </Card>
  );
};

export default RuleCard;
